/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Guide_Formulas_Step1Inputs */

const en_gc_resources_guide_formulas_step1 = /** @type {(inputs: Gc_Resources_Guide_Formulas_Step1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In a blank sheet, enter Amount in A1. Put 120, 85 and 45 in A2, A3 and A4.`)
};

const zh_gc_resources_guide_formulas_step1 = /** @type {(inputs: Gc_Resources_Guide_Formulas_Step1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在空白工作表的 A1 输入 Amount，在 A2、A3、A4 分别输入 120、85、45。`)
};

/**
* | output |
* | --- |
* | "In a blank sheet, enter Amount in A1. Put 120, 85 and 45 in A2, A3 and A4." |
*
* @param {Gc_Resources_Guide_Formulas_Step1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_guide_formulas_step1 = /** @type {((inputs?: Gc_Resources_Guide_Formulas_Step1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Guide_Formulas_Step1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_guide_formulas_step1(inputs)
	return zh_gc_resources_guide_formulas_step1(inputs)
});
export { gc_resources_guide_formulas_step1 as "gc.resources.guide.formulas.step1" }